/**
 * Converts a string to a URL-friendly slug
 * @param {string} text - The text to convert to a slug
 * @returns {string} - URL-friendly slug
 */
export const slugify = (text) => {
    if (!text) return '';

    return text
        .toString()
        .toLowerCase()
        .trim()
        .replace(/\s+/g, '-')           // Replace spaces with -
        .replace(/[^\w-]+/g, '')       // Remove all non-word chars (except -)
        .replace(/--+/g, '-')         // Replace multiple - with single -
        .replace(/^-+/, '')             // Trim - from start of text
        .replace(/-+$/, '');            // Trim - from end of text
};

/**
 * Generates a blog URL from the heading
 * @param {string} heading - The blog post heading
 * @returns {string} - The blog URL path segment
 */
export const getBlogSlug = (heading) => {
    return slugify(heading);
};

/**
 * URL slug for a blog post. Uses the fixed Firestore `slug` field when present,
 * so editing a heading never changes the post's URL; otherwise falls back to the heading.
 * @param {{slug?: string, heading?: string}} post
 * @returns {string}
 */
export const getPostSlug = (post) => slugify((post && (post.slug || post.heading)) || '');
